module.exports = __webpack_public_path__ + "img/Device-Test-Lit.c3d671a6.png";